import { render, staticRenderFns } from "./ProductsIcon.vue?vue&type=template&id=636b2b53&scoped=true&"
import script from "./ProductsIcon.vue?vue&type=script&lang=js&"
export * from "./ProductsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636b2b53",
  null
  
)

export default component.exports